<template>
    <div id="app">
      <!--  -->
        <router-view name="header" class="app-header"></router-view>
        <main class="app-main">
            <fade-transition origin="center" mode="out-in" :duration="250">
                <router-view/>
            </fade-transition>
        </main>
        <router-view name="footer"></router-view>
    </div>
</template>
<script>


export default {
  components: {}
};
</script>

<style>
html, body, #app {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 使应用占满整个视口高度 */
  overflow: hidden; /* 防止出现全局滚动条 */

}

.app-header {
  height: 48px;
  color: white; /* 头部文字颜色 */
  line-height: 48px; /* 使文字垂直居中 */
  text-align: center; /* 使文字水平居中 */
}

.app-main1 {
  flex: 1; /* 使内容区域填充剩余空间 */
}
</style>